/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import mapKeys from 'lodash/mapKeys';
import IntlMsg from 'lorautils/intl/IntlMsg';
import PieChart from '../PieChart';
import styles from './styles.scss';


function toSeries(seriesData) {
  const sum = _.sum(_.values(seriesData));
  return {
    label: {
      normal: {
        formatter: params => params.name,
        fontSize: 10,
      },
      emphasis: {
        formatter: params => params.name,
      },
    },
    data: _.map(seriesData, (value, name) => ({
      name,
      value,
      label: {
        normal: {
          position: value / sum < 0.1 ? 'outside' : 'inside',
        },
      },
      labelLine: {
        normal: {
          length: 5,
          length2: 5,
        },
      },
    })),
  };
}

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  seriesData: React.PropTypes.object.isRequired,
  keyName: React.PropTypes.string.isRequired,
};

class GatewayPie extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'network.analytics.gateway.pie');
  }

  render() {
    const { keyName } = this.props;
    let { seriesData } = this.props;
    seriesData = mapKeys(seriesData, (value, key) => this.intlMsg.msg(`${keyName}.${key}`));
    const title = {
      text: this.intlMsg.msg(`title.${keyName}`),
      x: 'center',
      y: 'bottom',
      textStyle: {
        fontSize: 16,
        fontWeight: 400
      }
    };
    return (
      <div className={styles.chart}>
        <PieChart title={title} series={[toSeries(seriesData)]} />
      </div>
    );
  }
}

GatewayPie.propTypes = propTypes;
export default connect(
  () => ({}),
  {},
)(injectIntl(GatewayPie));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/GatewayView/coms/GatewayPie/index.jsx